(function () {
    window.js = window.js || {};
    js.contactUs = (function () {
        function initialize(domElm) {
            console.log('initializing contact us form');
            var nonFormElements = Array.prototype.slice.call(domElm.querySelectorAll('.js-non-form-element'));
            var leftContent = domElm.querySelector('.js-contact-us__left-content');
            nonFormElements.forEach(function (elm) {
                leftContent.appendChild(elm);
            });
        }

        return {
            initialize: initialize
        };
    })();
})();